import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useNotification } from 'src/contexts/notification.context'
import {
  getClassroomRequest,
  updateClassroomRequest,
} from 'src/services/api.service'
import { BackLink } from 'src/components/common'
import { routes } from 'src/navigation/routes'
import ClassroomForm from './form'

export const EditClassroom = () => {
  const history = useHistory()
  const { wrapCallback } = useNotification()
  const { id } = useParams()
  const [values, setValues] = useState(null)

  useEffect(() => {
    const fetchAsync = async () => {
      const response = await getClassroomRequest(id)
      setValues(response.data.item)
    }
    fetchAsync()
  }, [id])

  const onSubmit = (values) => {
    wrapCallback(async () => {
      await updateClassroomRequest(id, values)
      history.replace(routes.classrooms.index)
    })
  }

  return (
    <>
      <div className="sectionHb-top">
        <BackLink to={routes.classrooms.index} />
        <h2 className="sectionHb-title">Edit Classroom</h2>
      </div>

      <div className="sectionHb-block purchaseHb">
        <div className="sectionHb-block__wrap">
          {values ? (
            <ClassroomForm initialValues={values} onSubmit={onSubmit} />
          ) : (
            <div>Loading...</div>
          )}
        </div>
      </div>
    </>
  )
}
